import React from 'react';
import Slider from 'react-slick';
import observeRootStore from '../../components/hoc/observeRootStore';

import Carousel from '../../components/carousel';
import Slide from './slide';
import * as constants from '../../appConstants';

export class CarouselCountries extends Carousel {
    constructor() {
        super();

        this.state = {
            carouselSettings: {
                className: 'carousel',
                dots: false,
                infinite: false,
                slidesToScroll: 3,
                slidesToShow: 3,
                speed: 300
            }
        }
    }

    toggleMap = e => {
        this.props.rootStore.uiStore.selectedState = null;
        this.props.rootStore.uiStore.activeMap = e.currentTarget.dataset.country;
    };

    render() {
        return (
            <Slider {...this.state.carouselSettings}>
                <Slide sid="ca" data-country={constants.CANADA} onClick={this.toggleMap}>Canada</Slide>
                <Slide sid="us" data-country={constants.UNITED_STATES} onClick={this.toggleMap}>United States</Slide>
                <Slide sid="mx" data-country={constants.MEXICO} onClick={this.toggleMap}>Mexico</Slide>
            </Slider>
        );
    }
}

export default observeRootStore(CarouselCountries);
